import { UpdateUserPreferencesDTO } from './user-preferences.types';

/**
 * Get current user's job alert preferences
 */
export class GetUserPreferences {
  static readonly type = '[User Preferences] Get Preferences';
}

/**
 * Update current user's job alert preferences
 */
export class UpdateUserPreferences {
  static readonly type = '[User Preferences] Update Preferences';
  constructor(public dto: UpdateUserPreferencesDTO) {}
}

/**
 * Clear preferences state
 */
export class ClearUserPreferences {
  static readonly type = '[User Preferences] Clear Preferences';
}
